import { render, staticRenderFns } from "./wf-dropdown-select-edit.vue?vue&type=template&id=2dcf56f5&scoped=true&"
import script from "./wf-dropdown-select-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-dropdown-select-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-dropdown-select-edit.vue?vue&type=style&index=0&id=2dcf56f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf56f5",
  null
  
)

export default component.exports